import React from 'react'
// import _ from 'lodash'
import combineClassNames from '../../helpers/combineClassNames'
// import Image from '../image'
import useStyles from './cart-line-item-style'

const CartLineItemPlaceholderView = () => {
  // style
  const styles = useStyles()

  return (
    <div
      className={combineClassNames([
        styles.row,
        styles.container,
        styles.containerLoading,
      ])}
    >
      <div
        className={
          combineClassNames([
            styles.thumbnail,
          ])
        }
      >
        <div
          className={combineClassNames([
            styles.thumbnailImage,
            styles.loadingBlock,
          ])}
        />
      </div>
      <div
        className={combineClassNames([
          styles.body,
        ])}
      >
        <div
          className={combineClassNames([
            styles.row,
            styles.contentContainer,
          ])}
        >

          <div
            className={combineClassNames([
              styles.column,
              styles.content,
            ])}
          >
            <div
              className={combineClassNames([
                styles.variant,
                styles.loadingBlock,
              ])}
              style={{
                width: '60%',
                height: '1.6rem',
              }}
            />
            <div
              className={combineClassNames([
                styles.variant,
                styles.loadingBlock,
              ])}
              style={{
                width: '20%',
                height: '1.4rem',
              }}
            />
            <div
              className={combineClassNames([
                styles.variant,
                styles.loadingBlock,
              ])}
              style={{
                width: '25%',
                height: '1.4rem',
              }}
            />
          </div>
          <div
            className={combineClassNames([
              styles.column,
              styles.controls,
            ])}
          >
            <div>
              <div
                className={combineClassNames([
                  styles.quantity,
                  styles.loadingBlock,
                ])}
                style={{
                  width: '6rem',
                  height: '2rem',
                }}
              />
            </div>
            {/* <CurrencyFormat
              className={styles.subtotalAmount}
              currency={currency}
              value={mainPropertyTotalPrice}
            /> */}
            <div
              className={combineClassNames([
                styles.subtotalAmount,
                styles.loadingBlock,
              ])}
              style={{
                width: '4rem',
                height: '1.4rem',
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default CartLineItemPlaceholderView
